export default "__VITE_ASSET__BLAKZjYo__"